var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19738_129669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 1H20.667C22.2248 1.00018 23.5 2.28414 23.5 3.88281V20.1172C23.5 21.7159 22.2248 22.9998 20.667 23H3.33301C1.77521 22.9998 0.5 21.7159 0.5 20.1172V3.88281C0.5 2.28414 1.77521 1.00018 3.33301 1Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.519 8.5685L13.2228 7.25329V10.7605H16.6793L15.3831 9.44534L17.3216 7.47837L16.4574 6.60156L14.519 8.5685ZM7.54375 6.60156L6.67969 7.47837L8.61809 9.44534L7.32195 10.7605H10.7784V7.25329L9.48222 8.5685L7.54375 6.60156ZM16.6793 13.241H13.2228V16.7482L14.519 15.433L16.4574 17.4L17.3216 16.5231L15.3831 14.5562L16.6793 13.241ZM8.61809 14.5562L6.67969 16.5231L7.54375 17.4L9.48222 15.433L10.7784 16.7482V13.241H7.32195L8.61809 14.5562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19738_129669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.c6b4cafddededdbcc50e9441ac3407ce.svg";
export { ForwardRef as ReactComponent };